"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoEndpointKeys = void 0;
var UserInfoEndpointKeys;
(function (UserInfoEndpointKeys) {
    UserInfoEndpointKeys["GetUserProfile"] = "get.userprofile";
    UserInfoEndpointKeys["GetUserTypeInfo"] = "get.userTypeInfo";
})(UserInfoEndpointKeys || (exports.UserInfoEndpointKeys = UserInfoEndpointKeys = {}));
